import * as R from 'ramda';
import axios from 'axios';
import {URLS} from 'js/common';

const createContentMetadataUrl = R.replace('__CONTENT_METADATA_ID__');

const creatorNotificationApiClient = {
    async notifyCreatorContentRejected(contentMetadataId, ...requestArgs) {
        const {notify_content_rejected} = URLS;
        const {data} = await axios.post(
            createContentMetadataUrl(contentMetadataId, notify_content_rejected),
            ...requestArgs
        );

        return data;
    },
    async notifyCreatorDoNotDistribute(contentMetadataId, ...requestArgs) {
        const {notify_to_not_post} = URLS;
        const {data} = await axios.post(
            createContentMetadataUrl(contentMetadataId, notify_to_not_post),
            ...requestArgs
        );

        return data;
    },
    async notifyCreatorToPost(contentMetadataId, ...requestArgs) {
        const {notify_to_post} = URLS;
        const {data} = await axios.post(
            createContentMetadataUrl(contentMetadataId, notify_to_post),
            ...requestArgs
        );

        return data;
    }
};

export default creatorNotificationApiClient;



// WEBPACK FOOTER //
// ./api_clients/creator_notification_api_client.js